import {
  AuthResource,
  SignUpResource,
  ActivateAccountResource,
  MySelfResource,
  ForgotPasswordResource,
  ResetPasswordResource,

  UserResource,
  UserCreateResource,
  UserReadResource,
  UserUpdateResource,
  UserDeleteResource,

  LineResource,
  LineCreateResource,
  LineUpdateResource,
  LineDeleteResource,

  PolResource,
  PolCreateResource,
  PolUpdateResource,
  PolDeleteResource,

  SettingResource,
  SettingCreateResource,
  SettingUpdateResource,
  SettingDeleteResource,

} from "./resources";

export default {
  authenticate({ email, password }) {
    return AuthResource.save({}, { email, password });
  },
  mySelf() {
    return MySelfResource.get();
  },
  /*signUp({ email, password, displayname, fullname }) {
    return SignUpResource.save({}, { email, password, displayname, fullname });
  },*/
  signUp(user) {
    return SignUpResource.save({}, user);
  },
  activateAccount({ token }) {
    return ActivateAccountResource.get({ token }, {});
  },
  forgotPassword({ email }) {
    return ForgotPasswordResource.save({ email });
  },
  resetPassword(obj) {
    return ResetPasswordResource.save({}, obj);
  },
  createPerson(person) {
    return CreatePersonResource.save({},person);
  },
  getPersons() {
    return PersonResource.get();
  },
  getPersonHistory(id) {
    return PersonHistoryResource.get({ id }, {});
  },
  deletePerson(id) {
    return PersonDeleteResource.delete({ id }, {});
  },
  deactivatePerson(id) {
    return PersonDeactivateResource.update({ id }, {});
  },
  updatePerson(person) {
    return PersonUpdateResource.update({ id: person._id }, person);
  }, 
  getUsers() {
    return UserResource.get();
  },
  createUser(user) {
    return UserCreateResource.save({},user);
  },
  readUser({id}){
    return UserReadResource.get({id}, {});
  },
  deleteUser(id) {
    return UserDeleteResource.delete({ id }, {});
  },
  updateUser(user) {
    return UserUpdateResource.update({ id: user._id }, user);
  }, 
  getEvents(query) {
    return EventResource.get(query, {});
  },
  deleteEvent(id) {
    return EventDeleteResource.delete({ id }, {});
  },
  updateEvent(event) {
    return EventUpdateResource.update({ id: event._id }, event);
  }, 
  createEvent(event) {
    return EventCreateResource.save({},event);
  },
  getLines() {
    return LineResource.get();
  },
  createLine(line) {
    return LineCreateResource.save({},line);
  },
  updateLine(line) {
    return LineUpdateResource.update({ id: line._id }, line);
  }, 
  deleteLine(id) {
    return LineDeleteResource.delete({ id }, {});
  },
  getPols() {
    return PolResource.get();
  },
  createPol(pol) {
    return PolCreateResource.save({},pol);
  },
  updatePol(pol) {
    console.log("API pol ", pol)
    return PolUpdateResource.update({ id: pol._id }, pol);
  }, 
  deletePol(id) {
    return PolDeleteResource.delete({ id }, {});
  },
  getSettings() {
    return SettingResource.get();
  },
  createSetting(setting) {
    return SettingCreateResource.save({},setting);
  },
  updateSetting(setting) {
    return SettingUpdateResource.update({ id: setting._id }, setting);
  }, 
  deleteSetting(id) {
    return SettingDeleteResource.delete({ id }, {});
  },
};
